import { dateService } from '@/core/services/date'
import { BookFormModel } from '../types/models/book-form.model'
import { CreateTripModel } from '../types/models/create-trip.model'

export function createTripToJson(input: BookFormModel & CreateTripModel) {
  return {
    full_name: input.fullName,
    from_point_lat: input.fromPointLat.toString(),
    from_point_long: input.fromPointLong.toString(),
    to_point_lat: input.toPointLat.toString(),
    to_point_long: input.toPointLong.toString(),
    from_point_name: input.fromPointName,
    to_point_name: input.toPointName,
    from_point_details: input.fromPointDetails,
    to_point_details: input.toPointDetails,
    date:
      input.date instanceof Date
        ? dateService.dateToYyMmDd(input.date)
        : input.date,
    time:
      input.time instanceof Date
        ? dateService.timeToHI(input.time)
        : input.time,
    country_id: input.countryId,
    email: input.email,
    phone_number: input.phoneNumber,
    flight_number: input.flightNumber,
    passengers: input.passengers,
    checked_luggage: input.checkedLuggage,
    hand_luggage: input.handLuggage,
    vehicle_size: input.vehicleSizeId,
    invitation_from_user_id: input.invitationFromUserId,
    relation_with_passenger: input.relationWithPassenger || '',
    child_seat: input.childSeats,
    booster: input.booster,
    carrier: input.carrier,
    note: input.note,
    pickup_time: input.pickupTime,
    waiting_time: input.waitingTime,
    meeting_point_id: input.meetingPointId || '',
    meeting_point_name: input.meetingPointName || '',
  }
}
